import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'utils/mediaQueries';

import Favorites from 'routes/MyAccount/routes/Favorites';

import Modal from 'components/Modal';
import ScrollableContent from 'components/ScrollableContent';

class FavoritesModal extends Component {
  render() {
    const { closeModal, show } = this.props;
    return (
      <Modal show={show} onCloseClick={closeModal} title="Favorites">
        <ScrollableContentWrapper>
          <ScrollableContent>
            <Content>{show && <Favorites modal />}</Content>
          </ScrollableContent>
        </ScrollableContentWrapper>
      </Modal>
    );
  }
}

FavoritesModal.propTypes = {
  show: PropTypes.bool,
  closeModal: PropTypes.func,
};

const ScrollableContentWrapper = styled.div`
  position: relative;
  height: 100%;
`;

const Content = styled.div`
  padding: 15px;
  width: 100%;
  margin: 0 auto;

  ${media.tablet`
    padding: 0;
  `};
`;

export default FavoritesModal;
